import type { CliConfig } from "@/lib/cli/cli-config";
import { configReadString } from "@/lib/string/config-read-string";
export function readUser(value: unknown): CliConfig["user"] {
  if (!value || typeof value !== "object") {
    return undefined;
  }
  const candidate = value as Record<string, unknown>;
  const user = {
    id: configReadString(candidate.id),
    name: configReadString(candidate.name),
    email: configReadString(candidate.email),
  };

  return user.id && user.name && user.email
    ? { id: user.id, name: user.name, email: user.email }
    : undefined;
}
